import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Portfolio',
    description: 'Personal portfolio with selected data mining and web development projects, skills, and a way to get in touch.',
    url: getOrigin()
}
